import React from 'react';

function Footer() {
    return (
        <footer className="bg-acid border-t-4 border-black py-8 mt-auto">
            <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-[10px] md:text-xs text-black uppercase tracking-widest">
                <p className="mb-4 md:mb-0">&copy; {new Date().getFullYear()} QUIZ PWA</p>
                <div className="flex space-x-6">
                    <a href="/privacy" className="hover:underline transition-none">Privacy</a>
                    <a href="/terms" className="hover:underline transition-none">Terms</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer; 